var _defs, _text, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 432.949,
    height: 89.799,
    viewBox: "0 0 432.949 89.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.a{font-size:57px;font-family:Satoshi;font-weight:600;letter-spacing:0.03em;}.c{fill:url(#a);}.d{fill:url(#b);}.e{fill:url(#c);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1,
    y1: 0.866,
    x2: 0.024,
    y2: 0.021,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7c598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8886"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b4bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9573db"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.077,
    y1: 0.108,
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#44dec5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ebcfa"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "a",
    transform: "translate(115.949 65.377)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SnapBooks"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M553.715,304.8H477.194a7.631,7.631,0,0,1-7.621-7.617V222.621A7.635,7.635,0,0,1,477.194,215h76.521a7.635,7.635,0,0,1,7.622,7.621v74.561A7.631,7.631,0,0,1,553.715,304.8Zm-76.521-84.438a2.265,2.265,0,0,0-2.256,2.26v74.561a2.268,2.268,0,0,0,2.256,2.26h76.521a2.267,2.267,0,0,0,2.256-2.26V222.621a2.265,2.265,0,0,0-2.256-2.26Z",
    transform: "translate(-469.573 -215)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.395 11.516)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 28.954)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.816)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M612.959,329.358v20.416a1.992,1.992,0,0,0,1.986,1.986H632.13a1.992,1.992,0,0,0,1.986-1.986V313.54a.534.534,0,0,0-.913-.375,88.26,88.26,0,0,1-19.225,14.466A1.981,1.981,0,0,0,612.959,329.358Z",
    transform: "translate(-612.959 -313.006)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.901 17.784)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M555.047,364.14v10.918a1.992,1.992,0,0,0,1.986,1.986h17.191a1.992,1.992,0,0,0,1.986-1.986v-17a1.979,1.979,0,0,0-2.8-1.8,97.725,97.725,0,0,1-16.854,5.963A1.984,1.984,0,0,0,555.047,364.14Z",
    transform: "translate(-555.047 -356.074)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 25.351)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M497.168,378.114v7.7a1.992,1.992,0,0,0,1.986,1.986h17.185a1.992,1.992,0,0,0,1.986-1.986v-9.436a1.989,1.989,0,0,0-2.366-1.947,103.749,103.749,0,0,1-16.83,1.7A1.986,1.986,0,0,0,497.168,378.114Z",
    transform: "translate(-497.168 -374.398)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.816)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M632.13,242.889H614.945a1.992,1.992,0,0,0-1.986,1.986v35.348a1.992,1.992,0,0,0,3,1.714,87.383,87.383,0,0,0,17.582-13.665,2,2,0,0,0,.573-1.405V244.875A1.992,1.992,0,0,0,632.13,242.889Z",
    transform: "translate(-612.959 -242.889)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.901)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M574.224,242.889H557.033a1.992,1.992,0,0,0-1.986,1.986v45.336a1.98,1.98,0,0,0,2.469,1.927,97.069,97.069,0,0,0,17.58-6.508,1.991,1.991,0,0,0,1.114-1.793V244.875A1.992,1.992,0,0,0,574.224,242.889Z",
    transform: "translate(-555.047 -242.889)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M516.339,242.889H499.154a1.986,1.986,0,0,0-1.986,1.986v48.679a1.989,1.989,0,0,0,2.014,1.993,103.892,103.892,0,0,0,17.54-1.849,1.988,1.988,0,0,0,1.6-1.957V244.875A1.992,1.992,0,0,0,516.339,242.889Z",
    transform: "translate(-497.168 -242.889)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.12407469449a48074325cb691d842642.svg";
export { ForwardRef as ReactComponent };